import React from 'react';
import TripUpdatesPage from '../components/trip-updates-page';
export default function TripUpdates() {
    return (
        <>
	    <TripUpdatesPage />
        </>
    );
};
